import React from 'react';

class Others extends React.Component {
    render() {
        return (
            <div>
                <h1>Others Page</h1>
                <p>Content for the Others page.</p>
            </div>
        );
    }
}

export default Others;